import React from "react";
import Aarvek from "./Aarvek";

function App() {
  return <Aarvek />;
}

export default App;
